/**
 * NHA Parent Relations phone line (Mon–Fri, 8:00am–4:30pm ET). Single source of truth for
 * everywhere guardians are told to call — login screen help text, volunteer-issue banner, etc.
 */
export const PARENT_RELATIONS_PHONE_DISPLAY = '877-642-7471';
export const PARENT_RELATIONS_PHONE_TEL = 'tel:8776427471';
